import React, { useCallback, useState } from 'react'
import { useRouter } from 'next/router'
import { resendVerificationEmail } from '@/services/api/ellisIslandClient/ellisIslandClient'
import useAuth from '@/services/hooks/useAuth'
import useSiteAssets from '@/services/hooks/useSiteAssets'
import { buildShortbreadUrl } from '@/utils'
import { Button, Type } from '../common'
import { getPersistedAuth } from '../context/AuthContext/utils'
import { Checkmark } from '../svg'

const VerifyAccount = () => {
  const { user, redirect } = useAuth()
  const [emailSent, setEmailSent] = useState(false)
  const router = useRouter()
  const { ellisIslandClientId } = useSiteAssets()

  const handleClick = useCallback(
    async (event: React.FormEvent) => {
      const { token } = getPersistedAuth()
      setEmailSent(true)
      const emailRedirectUrl = redirect
        ? buildShortbreadUrl(redirect)
        : buildShortbreadUrl(router.asPath)
      event.preventDefault()
      !!token &&
        resendVerificationEmail(token, emailRedirectUrl, ellisIslandClientId)
    },
    [redirect, router]
  )

  return (
    <div>
      <Type
        variant="title-md"
        as="h3"
        className="-mt-6 mb-5 text-center font-bold"
      >
        Verify your email address
      </Type>
      <Type variant="paragraph-md" as="p" className="mb-5 text-center">
        We’ve sent a verification link to {user?.email}. Check your inbox and
        spam. Open the email and follow the instructions.
      </Type>

      <div className="relative pt-10">
        {emailSent && (
          <Type
            variant="paragraph-md"
            as="p"
            className="absolute left-0 right-0 top-0 font-bold italic text-gray"
          >
            <span className="flex items-center justify-center">
              <Checkmark className="mr-2 h-5 w-5" />
              <span>Email Sent</span>
            </span>
          </Type>
        )}

        <Type variant="paragraph-md" as="p" className="text-center">
          Didn’t get the verification email?
        </Type>

        <Button
          onClick={handleClick}
          variant="link"
          disabled={emailSent}
          className="full flex w-full items-center justify-center font-bold"
        >
          <span>Resend Verification Email</span>
        </Button>
      </div>
    </div>
  )
}

export default VerifyAccount
